//core
import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import arePropsEqual from "react-fast-compare";

//icons
import {Delete, Edit} from "@mui/icons-material";
import { PaymentIcon } from "../../../../../../UI/Icons";

//hooks
import { usePermissions } from "../../../../../../../store/common/configuration/usePermissions";
import { useFlatFee } from "../../../../../../../store/admin/flatFee/useFlatFee";

//context
import { usePayoutsContext } from "../../PayoutsContext";

//components
import ActionIconButton from "../../../../../../UI/Buttons/ActionIconButton";
import RemovePayment from "../RemovePayment";
import MuiModal from "../../../../../../UI/MuiModal";

export interface ITableActions {
  data: any;
}

const TableActions: React.FC<ITableActions> = ({ data }): JSX.Element => {
  const { t } = useTranslation();
  const { hasPermissions } = usePermissions();
  const context = usePayoutsContext();

  const { removePayout } = useFlatFee();

  const [showRemoveModal, setShowRemoveModal] = useState(false);

  const isPermissionShowEdit = hasPermissions(["api3.admin.flatfeecontroller.payment_edit"]);
  const isPermissionShowDelete = hasPermissions(["api3.admin.flatfeecontroller.payment_delete"]);

  const isDisabledActions = context.paymentData?.status?.toLowerCase() === "annulated" || context.paymentData?.status?.toLowerCase() === "closed";

  const handleEdit = () => {
    if (!context.showCreateUpdatePayout) {
      context.setShowCreateUpdatePayout(true);
    }
    context.setDataCreateUpdatePayout(data);
  }

  const handleRemove = () => {
    context.setDataCreateUpdatePayout(null);

    removePayout({
      paymentId: data.id
    })
    setShowRemoveModal(false);
  }

  const handleToggleRemoveModal = useCallback((state: boolean) => {
    setShowRemoveModal(state);
  }, [setShowRemoveModal]);

  return (
    <>
      {isPermissionShowDelete && (
        <ActionIconButton
          text={t("common.buttons.delete")}
          icon={<Delete fontSize="small" color={'primary'} />}
          onClick={() => handleToggleRemoveModal(true)}
          disabled={isDisabledActions}
        />
      )}

      {isPermissionShowEdit && (
        <ActionIconButton
          text={t("common.buttons.edit")}
          icon={<Edit fontSize="small" color={'primary'} />}
          onClick={handleEdit}
          disabled={isDisabledActions}
        />
      )}

      <MuiModal
        width={472}
        open={showRemoveModal}
        closeOnOutside={false}
        setToggleModal={handleToggleRemoveModal}
      >
        <RemovePayment
          data={data}
          closeModal={handleToggleRemoveModal}
          removeClick={handleRemove}
        />
      </MuiModal>
    </>
  );
};

export default React.memo(TableActions, arePropsEqual);
